import { QueryDtoOf } from '@40seas/entities/common';
import { Payout } from '../payout.entity';
import { Buyer } from '@40seas/entities/buyers';

export class QueryPayoutDto extends QueryDtoOf(Payout, [Buyer]) {}
